<div class="sidePanelLogo__wrap">
  @if (!whiteLabel?.data?.logoDark) {
    @if (rebrandEnabled()) {
      @if (ppMobile) {
        <pp-icon
          class="sidePanelLogo__close"
          ppClass="setSize24"
          data-testid="sidePanelRebrandClose"
          [ppSVG]="iconMap[EIconPath.GALLERY_CLOSE]"
          (click)="collapsePanel()"
        ></pp-icon>
      } @else {
        <pp-icon
          class="sidePanelLogo__icon"
          data-testid="sidePanelRebrandLogo"
          [ppSVG]="iconMap[EIconPath.LOGO_SMALL_REBRAND]"
        ></pp-icon>
      }
    } @else {
      <img
        class="sidePanelLogo__img"
        [src]="ppMobile ? EIconPath.GALLERY_CLOSE : EIconPath.LOGO_SMALL"
        (click)="ppMobile ? collapsePanel() : ''"
      />
    }
  }

  @if (whiteLabel?.data?.logoDark) {
    <img
      class="sidePanelLogo__img sidePanelLogo__img--custom"
      [ppSecureSrc]="'api/v1/images/' + whiteLabel?.data?.logoDark + '/file/size/bounded/400'"
    />
  }
</div>
